import {
  ON_START_CHECK_PLANING_USER,PROJEKT_GET_CHECK_PLANING_USER,
  PROJEKT_ON_START_GET_CARD_DETAILS,PROJEKT_ON_GET_CARD_DETAILS,PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS,
  PROJEKT_ON_START_GET_FORTNOX_PROJECT,PROJEKT_ON_GET_FORTNOX_PROJECT,PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT,
  PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT,PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT,PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT,
  PROJEKT_ON_START_GET_PROJEKT,ON_START_GET_ORDER_ORGNR_PROJEKT,ON_GET_ORDER_ORGNR_PROJEKT,
  PROJEKT_ON_GET_PROJEKT,
  PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE,
	PROJEKT_ON_GET_BOARD_AUTOCOMPLETE,
  PROJEKT_ON_START_GET_PROJEKT_TIMELINE,
  PROJEKT_ON_GET_PROJEKT_TIMELINE,
  PROJEKT_ON_START_GET_PROJEKT_BY_FASER,
  PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT,
  PROJEKT_ON_GET_PROJEKT_TIME_REPORT,
	PROJEKT_ON_GET_BOARD_LIST_BY_USER,
  PROJEKT_ON_START_GET_USERS_CALENDAR_EVENTS,
  PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS,
  PROJEKT_ON_GET_USERS_CALENDAR_EVENTS,
  PROJEKT_ON_GET_PROJEKT_BY_FASER,
  PROJEKT_ON_START_UPDATE_PROJEKT,
  PROJEKT_ON_UPDATE_PROJEKT,
  PROJEKT_ON_ERROR_UPDATE_PROJEKT,
  PROJEKT_ON_START_GET_THIS_PROJEKT,PROJEKT_ON_START_GET_THIS_CPROJEKT,
  PROJEKT_ON_GET_THIS_PROJEKT,
  PROJEKT_ON_START_GET_BOARDS,
  PROJEKT_ON_GET_BOARDS,
  PROJEKT_ON_START_GET_THIS_BOARD,
  PROJEKT_ON_GET_THIS_BOARD,
  PROJEKT_ON_START_GET_DOKUMENT,
  PROJEKT_ON_GET_DOKUMENT,
  PROJEKT_ON_GET_TAGS,
  PROJEKT_ON_GET_STATS,
  PROJEKT_ON_START_UPDATE,
  PROJEKT_ON_UPDATE,
  PROJEKT_ON_GET_THIS_BOARD_AKTIVITET,
  PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET,
  PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET,
  PROJEKT_ON_GET_HISTORIK,
  PROJEKT_ON_GET_BOARD_TEMPLATES,
  PROJEKT_ON_UPDADE_BOARD_TEMPLATE,
  PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE,
  PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE,
  PROJEKT_GET_REGISTERED_TIME,
  PROJEKT_GET_TIME_TYPES,
  PROJEKT_GET_CALENDAR_EVENTS,
	PROJEKT_START_GET_CALENDAR_EVENTS,
	PROJEKT_ERROR_GET_CALENDAR_EVENTS,
 	PROJEKT_UPDATE_CALENDAR_EVENT,
	PROJEKT_START_UPDATE_CALENDAR_EVENT,
	PROJEKT_ERROR_UPDATE_CALENDAR_EVENT,
  ON_START_NEW_PROJEKT_KALKYL_ID,
  ON_NEW_PROJEKT_KALKYL_ID,
  ON_ERROR_NEW_PROJEKT_KALKYL_ID,
  ON_START_NEW_PROJEKT_ABOKALKYL_ID,
  ON_NEW_PROJEKT_ABOKALKYL_ID,
  ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID,
  ON_START_GET_PROJEKT_KALKYL_ID,
  ON_GET_PROJEKT_KALKYL_ID,
  ON_ERROR_GET_PROJEKT_KALKYL_ID,
  ON_START_DELETE_PROJEKT_KALKYL_RAD,
  ON_DELETE_PROJEKT_KALKYL_RAD,
  ON_ERROR_DELETE_PROJEKT_KALKYL_RAD,
  ON_START_UPDATE_PROJEKT_KALKYL_RAD,
  ON_UPDATE_PROJEKT_KALKYL_RAD,
  ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD,
  ON_ERROR_GET_ORDER_ORGNR,
  ON_START_GET_ORDER_ORGNR,
  ON_GET_ORDER_ORGNR,
  PROJEKT_ON_START_BUFFER_CARDS,
  PROJEKT_ON_ERROR_BUFFER_CARDS,
  PROJEKT_ON_BUFFER_CARDS,
  PROJEKT_ON_START_SEARCH_CARDS,
  PROJEKT_ON_ERROR_SEARCH_CARDS,
  PROJEKT_ON_SEARCH_CARDS,
  PROJEKT_ON_START_GET_TOOLTIPINFO,
  PROJEKT_ON_GET_TOOLTIPINFO,
  PROJEKT_ON_ERROR_GET_TOOLTIPINFO,
  PROJEKT_ON_START_GO_TO_BOARD,
  PROJEKT_ON_GO_TO_BOARD,
  PROJEKT_ON_ERROR_GO_TO_BOARD ,
  PROJEKT_ON_POST_TO_FLODE,
  PROJEKT_ON_START_POST_TO_FLODE,
  PROJEKT_ON_ERROR_POST_TO_FLODE,
  PROJEKT_ON_EDIT_TO_FLODE,
  PROJEKT_ON_START_EDIT_TO_FLODE,
  PROJEKT_ON_ERROR_EDIT_TO_FLODE,
  PROJEKT_ON_DELETE_TO_FLODE,
  PROJEKT_ON_START_DELETE_TO_FLODE,
  PROJEKT_ON_ERROR_DELETE_TO_FLODE,
  PROJEKT_ON_START_UPDATE_PROJEKT_BY_META,
  PROJEKT_ON_UPDATE_PROJEKT_BY_META,
  PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META,
  PROJEKT_ON_GET_ORGNR_COUNT_ALL,

  PROJEKT_ON_START_UPDATE_BOARD,
  PROJEKT_ON_UPDATE_BOARD,
  PROJEKT_ON_ERROR_UPDATE_BOARD,

  ON_SAVE_PROJEKT_CALC_ITEMS,
  ON_START_SAVE_PROJEKT_CALC_ITEMS,  
  ON_ERROR_SAVE_PROJEKT_CALC_ITEMS, 
  //JACK
  ON_START_ADD_PROJEKT_TIME_TYPE,ON_ADD_PROJEKT_TIME_TYPE,ON_ERROR_ADD_PROJEKT_TIME_TYPE,
  ON_UPPDATE_PROJEKT_TIME_TYPE,ON_DELETE_PROJEKT_TIME_TYPE,ON_NEW_PROJEKT_TIME_TYPE_CATEGORY,
  ON_DELETE_PROJEKT_TIME_TYPE_CATEGORY,ON_ADD_PROJEKT_NEW_TEMPLATE_BOARD,
  ON_UPDATE_PROJEKT_TEMPLATE_BOARD,ON_ERROR_UPDATE_PROJEKT_TIME_TYPE,ON_DELETE_PROJEKT_TEMPLATE_BOARD,
  PROJEKT_ON_ADD_EXTERN_PART_BOARD,
  PROJEKT_ON_START_ADD_EXTERN_PART_BOARD,
  PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD,
  PROJEKT_ON_GET_BOARD_BY_TOKEN,
  PROJEKT_ON_START_GET_BOARD_BY_TOKEN,
  PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN,
  PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN,
  PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN,
  PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN,
  ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,

  PROJEKT_KORT_ON_ADD_KOMMENTAR,
  PROJEKT_KORT_ON_START_ADD_KOMMENTAR,
  PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR,
  PROJEKT_KORT_ON_UPDATE_KOMMENTAR,
  PROJEKT_KORT_ON_START_UPDATE_KOMMENTAR,
  PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR,
  PROJEKT_KORT_ON_DELETE_KOMMENTAR,
  PROJEKT_KORT_ON_START_DELETE_KOMMENTAR,
  PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR,
  PROJEKT_KORT_ON_ADD_MEDARBETARE,
  PROJEKT_KORT_ON_START_ADD_MEDARBETARE,
  PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE,
  PROJEKT_KORT_ON_DELETE_MEDARBETARE,
  PROJEKT_KORT_ON_START_DELETE_MEDARBETARE,
  PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE,
  PROJEKT_KORT_ON_UPDATE_BESKRIVNING,
  PROJEKT_KORT_ON_START_UPDATE_BESKRIVNING,
  PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING,
  PROJEKT_KORT_ON_UPDATE_TITEL,
  PROJEKT_KORT_ON_START_UPDATE_TITEL,
  PROJEKT_KORT_ON_ERROR_UPDATE_TITEL,
  PROJEKT_KORT_ON_ADD_LABEL,
  PROJEKT_KORT_ON_START_ADD_LABEL,
  PROJEKT_KORT_ON_ERROR_ADD_LABEL,
  PROJEKT_KORT_ON_REMOVE_LABEL,
  PROJEKT_KORT_ON_START_REMOVE_LABEL,
  PROJEKT_KORT_ON_ERROR_REMOVE_LABEL,
  PROJEKT_KORT_ON_UPDATE_DEADLINE,
  PROJEKT_KORT_ON_START_UPDATE_DEADLINE,
  PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE,
  PROJEKT_KORT_ON_ADD_ATTATCHMENT,
  PROJEKT_KORT_ON_START_ADD_ATTATCHMENT,
  PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT,
  PROJEKT_KORT_ON_DELETE_ATTATCHMENT,
  PROJEKT_KORT_ON_START_DELETE_ATTATCHMENT,
  PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT,
  PROJEKT_KORT_ON_UPDATE_STATUS,
  PROJEKT_KORT_ON_START_UPDATE_STATUS,
  PROJEKT_KORT_ON_ERROR_UPDATE_STATUS,
  PROJEKT_KORT_ON_MOVE_CARD,
  PROJEKT_KORT_ON_START_MOVE_CARD,
  PROJEKT_KORT_ON_ERROR_MOVE_CARD,
  PROJEKT_KORT_ON_MAKE_COVER,
  PROJEKT_KORT_ON_START_MAKE_COVER,
  PROJEKT_KORT_ON_ERROR_MAKE_COVER,
  PROJEKT_KORT_ON_ADD_CHECKLIST,
  PROJEKT_KORT_ON_START_ADD_CHECKLIST,
  PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST,
  PROJEKT_KORT_ON_UPDATE_CHECKLIST,
  PROJEKT_KORT_ON_START_UPDATE_CHECKLIST,
  PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST,
  PROJEKT_KORT_ON_DELETE_CHECKLIST,
  PROJEKT_KORT_ON_START_DELETE_CHECKLIST,
  PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST,
  PROJEKT_KORT_ON_ADD_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_START_ADD_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_UPDATE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_START_UPDATE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_DELETE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_START_DELETE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM,
  PROJEKT_KORT_ON_FOLLOW_CARD, 
  PROJEKT_KORT_ON_START_FOLLOW_CARD,
  PROJEKT_KORT_ON_ERROR_FOLLOW_CARD, 
  PROJEKT_ON_START_GET_USERS_OUTLOOK_STATUS, 
  PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS,
  PROJEKT_ON_GET_USERS_OUTLOOK_STATUS,
  PROJEKT_ON_START_GET_PLANNED_TIME_PRESET,
  PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET,
  PROJEKT_ON_GET_PLANNED_TIME_PRESET,

  FETCH_START_SET_UNAUTHE

} from '../constants/ActionTypes'

import axios from 'util/Api' 
import { v4 as uuidv4 } from 'uuid';
import {history} from '../store'
import { isUndefined,isNull,isEmpty } from 'lodash';
import {RefreshUserInterface} from 'actions'
import moment from 'moment-timezone'
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'


const getClientIp = async () => {
  let Ipadress='0.0.0.0'
 /*  await fetch('https://geolocation-db.com/json/')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.IPv4});
      */
      return Ipadress
}

export const postMessageProjekt = (data, ProjectId, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_POST_TO_FLODE})
    const ipAdress='0.0.0.0'
    axios.post('projekt/flode/post', {body: encrypt(JSON.stringify({
      Message: data.Message,
      Uname: data.Uname, 
      Mentions: data.mentions ?? [], 
      Userid,
      ipAdress:ipAdress,
      ProjectId:ProjectId
    }))},
    {headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      conosle.log("postMessageProjekt",data)
      if(data.data.success) {
         let endata = decrypt(data.data.encryptedData,data.data.iv)
         console.log("postMessageProjekt1: ", endata);
         let ndate = JSON.parse(endata)
          dispatch({type: PROJEKT_ON_POST_TO_FLODE, payload: ndate.results.newFlode})
      }else{
         let Data = isUndefined(data.data.error)?data.data:data.data.error
         let endata = decrypt(Data.encryptedData,Data.iv)
         console.log("postMessageProjekt2: ", endata);
         let ndate = JSON.parse(endata)
         dispatch({type: PROJEKT_ON_ERROR_POST_TO_FLODE})
      }
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_POST_TO_FLODE})
      console.log(err)
    })
  }
}
export const updateMessageProjekt = (data, id, ProjectId, Userid) => {
  console.log(id)
  // console.log(data)
  return async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_EDIT_TO_FLODE})
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/flode/update', {body:encrypt(JSON.stringify({
      id,
      ProjectId,
      Message: data.Message,
      Date: data.Date, 
      ipAdress:ipAdress,
      Userid
    }))},{
    headers: { 'Authorization':`Bearer ${jwt}`} })
    .then( data => {
      console.log("updateMessageProjekt",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateMessageProjekt1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_EDIT_TO_FLODE, payload: ndate.results.newFlode})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateMessageProjekt2: ", endata);
        dispatch({type: PROJEKT_ON_ERROR_EDIT_TO_FLODE})
      }
      
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_EDIT_TO_FLODE})
      console.log(err)
    })
  }
}
export const deleteMessageProjekt = (id, ProjectId, Userid) => {
  return  async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_DELETE_TO_FLODE})
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/flode/delete', 
      {params: encrypt(JSON.stringify({ id, Userid , ipAdress:ipAdress,ProjectId})),
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      console.log("deleteMessageProjekt",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteMessageProjekt1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_DELETE_TO_FLODE, payload: ndate.results.newFlode})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteMessageProjekt2: ", endata);
        dispatch({type: PROJEKT_ON_ERROR_DELETE_TO_FLODE})
      }
     
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_DELETE_TO_FLODE})
      console.log(err)
    })
  }
}

export const createProject = (projekt) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Project.Creating")});
    axios.post('projekt', {body:encrypt(JSON.stringify({
      Userid: projekt.Userid,
      Afid: projekt.Afid,
      Orgnr: projekt.Orgnr,
      ProjectName: projekt.ProjectName,
      ProjectFas: projekt.ProjectFas,
      Medarbetare: projekt.Medarbetare,
      Deadline: projekt.Deadline,
      Lopande: projekt.Lopande,
      ProjectStatus: projekt.ProjectStatus,
      AvProId: projekt.AvProId,
      AccountName: projekt.AccountName,
      ProspektData: isUndefined(projekt.ProspektData) ? {AvtalsTyp:'', AvtalsOperator:''} : projekt.ProspektData,
      Taggar: isUndefined(projekt.Taggar) ? [] : projekt.Taggar,
      OrderId: isUndefined(projekt.OrderId) ? null : projekt.OrderId,
      GetDocument: isUndefined(projekt.getDocument) ? false : projekt.getDocument,
      GetKalkyl: isUndefined(projekt.getKalkyl) ? false : projekt.getKalkyl,
      GetKunddata: isUndefined(projekt.getKunddata) ? false : projekt.getKunddata,
      GetNotes: isUndefined(projekt.getNotes) ? false : projekt.getNotes,
      Kontakt: isUndefined(projekt.Kontakt) ? {} : projekt.Kontakt,
      intarnt: isUndefined(projekt.intarnt) ? false : projekt.intarnt,
      LeverantorOrgnr: isUndefined(projekt.LeverantorOrgnr) ? "" : projekt.LeverantorOrgnr,
      PrisListId: isUndefined(projekt.PrisListId) ? 0 : projekt.PrisListId,
    }))},{headers: { 'Authorization':   `Bearer ${jwt}`}})
    .then( data => {
      console.log("createProject",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createProject1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Project.create")});
        dispatch(getProject(projekt.Afid, projekt.Userid,ndate.result.ProjectId, 1))
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createProject2: ", endata);
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Project.create")});
      }
    }).catch(err => {
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Project.create")});
      console.log(err)
    })
  }
}

export const getProjects = (Afid, Userid, Page, PageSize, Searchword, StatusFilter, Filterstate, AutoComplete, SortObj) => {

  const sortObj = isUndefined(SortObj) ? null : SortObj

  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_PROJEKT})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/getByAfid', {params: encrypt(JSON.stringify({Afid, Userid, Offset: Page, PageSize,Searchword,StatusFilter,Filterstate,sortObj})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProjects",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjects1: ", endata);
        let ndate = JSON.parse(endata)
        if(isUndefined(AutoComplete)) {
          dispatch({type: PROJEKT_ON_GET_PROJEKT, payload: {...ndate, SortObj}})
        } else {
          dispatch({type: PROJEKT_ON_GET_PROJEKT_AUTOCOMPLETE, payload: ndate})
        }
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjects2: ", endata);
      }
      // console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getProjectsTimeline = (Afid, Userid, Searchword, StatusFilter, Filterstate) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_PROJEKT_TIMELINE})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('/projekt/getByAfidTimeline', {params: encrypt(JSON.stringify({Afid, Userid, Searchword,StatusFilter,Filterstate})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      // console.log(data)
      console.log("getProjectsTimeline",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjectsTimeline1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_PROJEKT_TIMELINE, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjectsTimeline2: ", endata);
      }
      //dispatch({type: PROJEKT_ON_GET_PROJEKT_TIMELINE, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getProjectsByFaser = (Afid, Userid, Searchword, StatusFilter, Filterstate, FasView=0) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_PROJEKT_BY_FASER})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('/projekt/getByAfidByFaser', {params: encrypt(JSON.stringify({Afid, Userid, Searchword,StatusFilter,Filterstate,FasView})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProjectsByFaser",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjectsByFaser1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_PROJEKT_BY_FASER, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjectsByFaser2: ", endata); 
      }
      // console.log(data)
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getUserCalendarEvents = (Afid, Userid, Users, FromDate, ToDate) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_USERS_CALENDAR_EVENTS})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('/projekt/getUserCalendarEvents', {params: encrypt(JSON.stringify({Afid, Userid, Users, FromDate, ToDate})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
			.then( data  => {
        console.log("getUserCalendarEvents",data)
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUserCalendarEvents1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_USERS_CALENDAR_EVENTS, payload: ndate})
        dispatch(RefreshUserInterface(Userid))
      }
      else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUserCalendarEvents2: ", endata);
        dispatch({type: PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS, payload: {message: translate("Error.Project.Calender.Events.get")}})
      }

      // console.log(data)
		
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_GET_USERS_CALENDAR_EVENTS, payload: err})
      console.log(err)
    })
  }
}
export const getProjectsTimeReport = (Afid, Userid, Searchword, StatusFilter, Filterstate, View = 1, DateObj = {
  Month: (moment().month()+1),
  Year: moment().year(),
}, init = true) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_PROJEKT_TIME_REPORT, payload: {init}})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('/projekt/getByAfidByTimeReport', {params: encrypt(JSON.stringify({Afid, Userid, Searchword,StatusFilter,Filterstate, View, DateObj})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProjectsTimeReport",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjectsTimeReport1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_PROJEKT_TIME_REPORT, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjectsTimeReport2: ", endata);
      }
      // console.log(data)
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const SendProjectToNextFas = (Afid, Userid, ProjectId, Searchword, StatusFilter, Filterstate, FasView) => {
  return (dispatch) => {
    // dispatch({type: PROJEKT_ON_START_GET_PROJEKT})
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/sendToNextFas', 
      {body: encrypt(JSON.stringify(
        {Afid, Userid, ProjectId}))
      },{headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("SendProjectToNextFas",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("SendProjectToNextFas1: ", endata);
        dispatch(getProjectsByFaser(Afid, Userid, Searchword, StatusFilter, Filterstate, FasView))
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("SendProjectToNextFas2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const MarkProjectInTable = (Afid, Userid, Page, PageSize, Searchword, StatusFilter, Filterstate, Mark, ProjectId) => {
  return (dispatch) => {
    // dispatch({type: PROJEKT_ON_START_GET_PROJEKT})
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/markProject', 
      {body: encrypt(JSON.stringify(
        {Afid, Userid, Mark, ProjectId}
      ))
      }
      ,{
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
        console.log("MarkProjectInTable",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("MarkProjectInTable1: ", endata);
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("MarkProjectInTable2: ", endata);
      }
      // console.log(data)
      // dispatch(getProjects(Afid, Userid, Page, PageSize, Searchword, StatusFilter, Filterstate))
    }).catch(err => {
      console.log(err)
    })
  }
}
//getProjectsCountOrgnr
export const getProjectsCountOrgnr = (Afid,userid, Orgnr) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/countOrgnr', {params: encrypt(JSON.stringify({ Afid, Orgnr,userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProjectsCountOrgnr",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjectsCountOrgnr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_ORGNR_COUNT_ALL, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjectsCountOrgnr2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getProjectsByOrgnr = (Afid, Userid, Orgnr, Page, PageSize, StatusFilter,searchword) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_PROJEKT})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/getByOrgnr', {params: encrypt(JSON.stringify({Afid, Userid, Offset: Page, PageSize,Orgnr,StatusFilter,searchword})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProjectsByOrgnr",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjectsByOrgnr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_PROJEKT, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjectsByOrgnr2: ", endata);
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Projects.get")});
      }
      // console.log(data)
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Projects.get")});
    })
  }
}
export const getProjectsByAvProId = (Afid, Userid, AvProId, Page, PageSize, StatusFilter) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_PROJEKT})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/getByAvProId', {params: encrypt(JSON.stringify({Afid, Userid, Offset: Page, PageSize,AvProId,StatusFilter})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProjectsByAvProId",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProjectsByAvProId1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_PROJEKT, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProjectsByAvProId2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getProject = (Afid, Userid, ProjectId,ToProject, listNumber) => {
  return (dispatch) => {
    if(!isUndefined(ToProject)){
    dispatch({type: PROJEKT_ON_START_GET_THIS_PROJEKT})
    }
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt', {params: encrypt(JSON.stringify({Afid, Userid, ProjectId})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getProject",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getProject1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_THIS_PROJEKT, payload: ndate.result})
      if(!isUndefined(ToProject)){
        history.push(
          {
            pathname: '/app/ProjektKort',
            state: { 
              ProjektId: ProjectId, 
            }
          }
        )
      }
      /**/
      dispatch(RefreshUserInterface(Userid))
      
      dispatch(GetDocByProjectId(Userid, ProjectId, 0))
      dispatch(getProjectOrderById(Afid,Userid,ProjectId, 0))
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getProject2: ", endata);
      }
      

    }).catch(err => {
      console.log(err)
    })
  }
}
export const CgetProject = (Afid, Userid, ProjectId,ToProject, listNumber) => {
  return (dispatch) => {
    if(!isUndefined(ToProject)){
    dispatch({type: PROJEKT_ON_START_GET_THIS_CPROJEKT})
    }
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt', {params: encrypt(JSON.stringify({Afid, Userid, ProjectId})),
      headers: { 'Authorization':`Bearer ${jwt}`}}).then( data => {
      console.log("CgetProject",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("CgetProject1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_THIS_PROJEKT, payload: ndate.result})
        if(!isUndefined(ToProject)){
          history.push(
            {
              pathname: '/app/ProjektKort',
              state: { 
                ProjektId: ProjectId, 
              }
            }
          )
        }
        /**/
        dispatch(RefreshUserInterface(Userid))
        
        dispatch(GetDocByProjectId(Userid, ProjectId, 0))
        dispatch(getProjectOrderById(Afid,Userid,ProjectId, 0))
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("CgetProject2: ", endata);
      }
    

    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateProjectById = (Afid, Userid, projekt) => {
  // console.log(data)
  return(dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_ON_START_UPDATE_PROJEKT})
    axios.put('projekt', {body:encrypt(JSON.stringify({
      Afid,
      Userid,
      projekt
    }))},
    {headers: { 'Authorization':`Bearer ${jwt}`} })
    .then( data => {
      console.log("updateProjectById",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateProjectById1: ", endata);
        dispatch(CgetProject(Afid, Userid, projekt.id)) 
        dispatch({type: PROJEKT_ON_UPDATE_PROJEKT, payload: {message: translate("Action.Project.save")}})
        dispatch(getBoards(Afid, Userid, projekt))
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateProjectById2: ", endata);
        dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT, payload: {message: translate("Error.Project.save")}})
      }
    
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT, payload: {message: translate("Error.Project.save")}})
      console.log(err)
    })
  }
}

export const getBoardTemplates = (Afid, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/boards/templates', {params: encrypt(JSON.stringify({Afid, Userid })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getBoardTemplates",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getBoardTemplates1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: PROJEKT_ON_GET_BOARD_TEMPLATES, payload: ndate.results})
      } else {
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getBoardTemplates2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteBoardTemplate = (Afid, Userid, TemplateId,TemplateName) => {
  return (dispatch) => {
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/boards/templates', {params: encrypt(JSON.stringify({Afid, Userid, TemplateId,TemplateName })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("deleteBoardTemplate",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteBoardTemplate1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_DELETE_PROJEKT_TEMPLATE_BOARD, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteBoardTemplate2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_PROJEKT_TIME_TYPE, payload: ndate.message});
      }
      dispatch(getBoardTemplates(Afid, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateBoardTemplate = (Afid, Userid, Columns, TemplateName, BoardColor, TemplateId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE})
    //Jack
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.put('projekt/boards/templates',  {body:encrypt(JSON.stringify({
      Afid,
      Userid,
      Columns,
      TemplateName,	
			BoardColor,
      TemplateId
    }))},
    { headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("updateBoardTemplate",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateBoardTemplate1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getBoardTemplates(Afid, Userid))
        dispatch({type: ON_UPDATE_PROJEKT_TEMPLATE_BOARD, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateBoardTemplate2: ", endata);
        dispatch({type: ON_ERROR_UPDATE_PROJEKT_TIME_TYPE, payload: data.message});
      }
      console.log(data)
    }).catch(err => {
      //dispatch({type: PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE, payload: {message: 'Error!'}})
      console.log(err)
    })
  }
}
export const updateBoardTemplateByMeta = (Afid, Userid, Meta, Value, TemplateName, TemplateId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_ON_START_UPDADE_BOARD_TEMPLATE})
    //Jack
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.put('projekt/boards/templatesMeta',  {body:encrypt(JSON.stringify({
      Afid,
      Userid,
      Meta, Value,
      TemplateId,TemplateName
    }))},{ headers: { 'Authorization':`Bearer ${jwt}`}}).then( data => {
      console.log("updateBoardTemplateByMeta",data)
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateBoardTemplateByMeta1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch(getBoardTemplates(Afid, Userid))
        dispatch({type: ON_UPDATE_PROJEKT_TEMPLATE_BOARD, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error) ? data.data : data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateBoardTemplateByMeta2: ", endata);
        const ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_PROJEKT_TIME_TYPE, payload: ndate.message});
      }
    
    }).catch(err => {
      //dispatch({type: PROJEKT_ON_ERROR_UPDADE_BOARD_TEMPLATE, payload: {message: 'Error!'}})
      console.log(err)
    })
  }
}

export const addBoard = (Afid, Userid, Board, projekt, BoardImage, Offset, Limit, Tab, TemplateId, Template, TemplateName,medarbetare) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    
    formData.append('files[]', BoardImage);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('BoardName', Board.boardName);
    formData.append('BoardDesc', Board.boardDesc);
    formData.append('start', Board.start);
    formData.append('end', Board.end);
    formData.append('lopande', Board.lopande);
    formData.append('ProjectId', projekt.id);
    formData.append('TemplateId', TemplateId);
    formData.append('Template', JSON.stringify(Template));
    formData.append('TemplateName', TemplateName);
    formData.append('medarbetare', medarbetare);

    axios.post('projekt/boards', 
    formData,
        {
        body: {
          Userid,
          Afid,
          BoardName: Board.boardName,
          BoardDesc: Board.boardDesc,
          start: Board.start,
          end: Board.end,
          lopande: Board.lopande,
          ProjectId: projekt.id,
          TemplateId,
          Template: JSON.stringify(Template),
          TemplateName,
          medarbetare
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      console.log(data)
      dispatch(getBoards(Afid, Userid, projekt, Offset, Limit, Tab))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const createTemplateBoard = (Afid, Userid, Template, TemplateName, BoardColor) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.post('projekt/boards/templates', 
        {
        body: {
          Userid,
          Afid,
          Template: JSON.stringify(Template),
          TemplateName,
					BoardColor,
        }},{
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      console.log(data)
      if (data.success) {
        dispatch({type: ON_ADD_PROJEKT_NEW_TEMPLATE_BOARD, payload: data.results});
        dispatch(getBoardTemplates(Afid, Userid))         
      }
      else{
        dispatch({type: ON_ERROR_ADD_PROJEKT_TIME_TYPE, payload: data.message});
      }
      
      // dispatch(getBoards(Afid, Userid, projekt, Page))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateBoard = (Afid, Userid, Board, projekt, BoardImage, RemoveImageFlag, Page) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    
    formData.append('files[]', BoardImage);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('BoardName', Board.boardName);
    formData.append('BoardDesc', Board.boardDesc);
    formData.append('BoardColor', Board.boardColor);
    formData.append('start', Board.start);
    formData.append('end', Board.end);
    formData.append('lopande', Board.lopande);
    formData.append('BoardId', Board.id);
    formData.append('BoardImageName', Board.BoardImageName);
    formData.append('RemoveImageFlag', RemoveImageFlag);
    formData.append('Medarbetare', Board.medarbetare);
    dispatch({type:PROJEKT_ON_START_UPDATE_BOARD})
    axios.put('projekt/boards', 
    formData,
        {
        body: {
          Userid,
          Afid,
          RemoveImageFlag,
          BoardName: Board.boardName,
          BoardDesc: Board.boardDesc,
          BoardColor: Board.BoardColor,
          start: Board.start,
          end: Board.end,
          lopande: Board.lopande,
          BoardImageName: Board.BoardImageName,
          BoardId: Board.id,
          Medarbetare: Board.medarbetare
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      console.log(data)
      if(data.success) {
        dispatch({type: PROJEKT_ON_UPDATE_BOARD, payload: data.Board})
        dispatch(getBoards(Afid, Userid, projekt, isUndefined(Page) ? 0 : Page))
      } else {
        dispatch({type: PROJEKT_ON_ERROR_UPDATE_BOARD})
      }
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_UPDATE_BOARD})
      console.log(err)
    })
  }
}

//
export const updateBoardByToken = (Afid, Userid, Board, projekt, BoardImage, RemoveImageFlag, Page) => {
  return (dispatch) => {
    const formData = new FormData()    
    formData.append('files[]', BoardImage);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('BoardName', Board.boardName);
    formData.append('BoardDesc', Board.boardDesc);
    formData.append('BoardColor', Board.boardColor);
    formData.append('start', Board.start);
    formData.append('end', Board.end);
    formData.append('lopande', Board.lopande);
    formData.append('BoardId', Board.id);
    formData.append('BoardImageName', Board.BoardImageName);
    formData.append('RemoveImageFlag', RemoveImageFlag);
    formData.append('Medarbetare', Board.medarbetare);
    dispatch({type:PROJEKT_ON_START_UPDATE_BOARD})
    axios.put('projekt/boardsByToken', 
    formData,
        {
        body: {
          Userid,
          Afid,
          RemoveImageFlag,
          BoardName: Board.boardName,
          BoardDesc: Board.boardDesc,
          BoardColor: Board.BoardColor,
          start: Board.start,
          end: Board.end,
          lopande: Board.lopande,
          BoardImageName: Board.BoardImageName,
          BoardId: Board.id,
          Medarbetare: Board.medarbetare
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(({data}) => {
      console.log(data)
      if(data.success) {
        dispatch({type: PROJEKT_ON_UPDATE_BOARD, payload: data.Board})
        dispatch(getBoards(Afid, Userid, projekt, isUndefined(Page) ? 0 : Page))
      } else {
        dispatch({type: PROJEKT_ON_ERROR_UPDATE_BOARD})
      }
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_UPDATE_BOARD})
      console.log(err)
    })
  }
}
//
export const deleteBoard = (Afid, Userid, Projekt, BoardId, Page, Limit, Tab) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/boards', { params:{BoardId},headers: {
      'Authorization':   `Bearer ${jwt}`
      }}).then(({data}) => {
        console.log(data)
        dispatch(getBoards(Afid, Userid, Projekt, isUndefined(Page) ? 0 : Page), Limit, Tab)
      }).catch(err => {
        console.log(err)
      })
  }
}

export const getBoardsAutoComplete = (Afid, Userid, projekt, Offset = 0, Limit = 50, Tab = -1, callback) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/boards', {
      params: {Afid, Userid, ProjectId: projekt.id, Offset, Limit, Tab},
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      dispatch({type: PROJEKT_ON_GET_BOARD_AUTOCOMPLETE, payload: data.results})
			if(callback){ 
				callback()
			}
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getBoards = (Afid, Userid, projekt, Offset, Limit, Tab = -1) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_BOARDS})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/boards', {
      params: {Afid, Userid, ProjectId: projekt.id, Offset, Limit, Tab},
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      dispatch({type: PROJEKT_ON_GET_BOARDS, payload: data.results})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getBoardById =(Afid, Userid, BoardId, Cdate, Init) => {
  return async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_THIS_BOARD, payload:Init})
    const jwt =  JSON.parse(localStorage.token);
    await axios.get('projekt/board', {
      params: {Afid, Userid, BoardId, Cdate},
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      if(data.success)
        dispatch({type: PROJEKT_ON_GET_THIS_BOARD, payload: {board: data.result, newData: data.newData}})
      else{
        if(!data.newData) console.log("Ingen ny data!")
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const bufferCardsToColumn = (Afid, Userid, BoardId, ColumnId, Offset) => {
  return async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_BUFFER_CARDS })
    const jwt =  JSON.parse(localStorage.token);
    await axios.get('projekt/bufferCardsToColumn', {
      params: {Afid, Userid, BoardId, ColumnId, Offset},
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      if(data.success){
        dispatch({type: PROJEKT_ON_BUFFER_CARDS, payload: data.results })
      }
      else{
        dispatch({type: PROJEKT_ON_ERROR_BUFFER_CARDS })
      }
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_BUFFER_CARDS })
      console.log(err)
    })
  }
}
export const handleSearchCards = (Afid, Userid, Searchstring, BoardId) => {
  return async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_SEARCH_CARDS })
    const jwt =  JSON.parse(localStorage.token);
    await axios.get('projekt/handleSearchCards', {
      params: {Afid, Userid, Searchstring, BoardId, Extern: 0},
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      if(data.success){
        dispatch({type: PROJEKT_ON_SEARCH_CARDS, payload: data.results })
      }
      else{
        dispatch({type: PROJEKT_ON_ERROR_SEARCH_CARDS })
      }
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_SEARCH_CARDS })
      console.log(err)
    })
  }
}
export const handleSearchCardsByToken = (Afid, Userid, Searchstring, BoardId) => {
  return async (dispatch) => {
    dispatch({type: PROJEKT_ON_START_SEARCH_CARDS })
    await axios.get('projekt/handleSearchCardsByToken', {
      params: {Afid, Userid, Searchstring, BoardId, Extern: 1}}
      ).then(({data}) => {
      if(data.success){
        dispatch({type: PROJEKT_ON_SEARCH_CARDS, payload: data.results })
      }
      else{
        dispatch({type: PROJEKT_ON_ERROR_SEARCH_CARDS })
      }
    }).catch(err => {
      dispatch({type: PROJEKT_ON_ERROR_SEARCH_CARDS })
      console.log(err)
    })
  }
}

export const addColumnToBoard = (Afid, Userid, BoardId, Column, Extern = 0) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/board/addColumn', {
      body: {Afid, Userid, BoardId, Column, Extern},
      headers: { 
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateColumnToBoard = (Afid, Userid, Column) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/board/updateColumn', {
      body: {Afid, Userid, Column}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}


export const removeColumnFromBoard = (Afid, Userid, ColumnId, BoardId, Extern = 0) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/board/removeColumn', {
      params:{Afid, Userid, ColumnId, BoardId, Extern},
      headers: { 
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const followAllCardsInColumn = (Afid, Userid, ColumnId, BoardId, Extern = 0) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/board/followAllCardsInColumn', {
      body:{Afid, Userid, ColumnId, BoardId, Extern},
      headers: { 
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateColumnOrder = (Afid, Userid, BoardId, Order, Extern = 0) => {
  return (dispatch) => {
    // console.log(arende)
    // const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/board/updateColumnOrder', {
      body: {
        Afid, Userid, BoardId, Order, Extern
    }},{headers: { 
      // 'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const setUnreadNotificationsRead = (Afid, Userid, CardId, Extern = 0) => {
  return (dispatch) => {
    // console.log(arende)
    // const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/board/setUnreadNotificationsRead', {
      body: {
				Afid, Userid, CardId, Extern
    }},{headers: { 
      // 'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateBoardByMetaList = (Afid, Userid, ProjectId, Offset, Limit, BoardId, Meta, Value, Tab = -1) => {
  return (dispatch) => {
    // console.log(arende)
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/board/updateBoardByMetaList', {
      body: {
        Afid, Userid, ProjectId, Offset, Limit, BoardId, Meta, Value, Tab
    }},{headers: { 'Authorization':   `Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      dispatch({type: PROJEKT_ON_GET_BOARDS, payload: data.results})
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateBoardByMeta = (Afid, Userid, BoardId, Meta, Value) => {
  return (dispatch) => {
    // console.log(arende)
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/board/updateBoardByMeta', {
      body: {
        Afid, Userid, BoardId, Meta, Value
    }},{headers: { 'Authorization':   `Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      // dispatch({type: PROJEKT_ON_GET_BOARDS, payload: data.results})
    }).catch(err => {
      console.log(err)
    })
  }
}
export const moveCard = (Afid, Userid, BoardId, Data, CardDetails, LogItem = {}, Extern = 0) => {
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    // console.log(arende)
    dispatch({type:PROJEKT_KORT_ON_START_MOVE_CARD})
    // const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/board/moveCard', {
      body: {
        Afid, Userid, BoardId, Data, CardDetails, LogItem, Extern,ipAdress
    }},{headers: { 
      // 'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success)dispatch({type: PROJEKT_KORT_ON_MOVE_CARD, payload: {success: data.success, message: translate("Action.Project.card.move")}})
      else dispatch({type: PROJEKT_KORT_ON_ERROR_MOVE_CARD, payload: {success: data.success, message: translate("Error.Project.card.move")}})
    }).catch(err => {
      console.log(err)
      dispatch({type: PROJEKT_KORT_ON_ERROR_MOVE_CARD, payload: {success: false, message: translate("Error.Project.card.move")}})
    })
  }
}
export const updateCard = (Afid, Userid, Card, CardId, attatch,ProjectId, BoardId, _Mentions, _Comment, Extern = 0) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()

    let Mentions = '[]'
    let Comment = isUndefined(_Comment) ? '' : _Comment

    try {
      Mentions = isUndefined(_Mentions) ? '[]' : JSON.stringify(_Mentions)
    } catch (err) {
      console.log(err)
    }
    
    formData.append('files[]', attatch);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('Card', JSON.stringify(Card));
    formData.append('CardId', CardId);
    formData.append('ProjectId', ProjectId);
    formData.append('BoardId', BoardId);
    formData.append('Mentions', Mentions);
    formData.append('Comment', Comment);
    formData.append('Extern', Extern);

    dispatch({type: PROJEKT_ON_START_UPDATE})

    axios.put('projekt/board/updateCard', 
    formData,
    {
      body:{Afid, Userid, Card: JSON.stringify(Card) ,CardId,ProjectId,BoardId,Mentions,Comment, Extern},
      headers: { 
        
        'Content-Type': 'multipart/form-data',
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_ON_UPDATE, payload: {success: data.success, message: translate("Action.Project.card.Save")}})
        else dispatch({type: PROJEKT_ON_UPDATE, payload: {success: data.success, message: translate("Error.Project.card.Save")}})
    }).catch(err => {
      console.log(err)
      dispatch({type: PROJEKT_ON_UPDATE, payload: {success: false, message: translate("Error.Project.card.Save")}})
    })
  }
}
export const addCardToColumn = (Afid, Userid, ColumnId, Card, BoardId, ProjectId, Extern = 0) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/board/addCard', {
      body: {Afid, Userid, ColumnId, Card, BoardId,ProjectId, Extern},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_ON_UPDATE, payload: {success: data.success, message: translate("Action.Project.card.create")}})
        else dispatch({type: PROJEKT_ON_UPDATE, payload: {success: data.success, message: translate("Error.Project.card.create")}})
    }).catch(err => {
      dispatch({type: PROJEKT_ON_UPDATE, payload: {success: false, message: translate("Error.Project.card.create")}})
      console.log(err)
    })
  }
}
export const addCommentToCard = (Afid, Userid, Card, BoardId, ProjectId, Comment, Mentions, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_ADD_KOMMENTAR})
    axios.post('projekt/board/card/comment', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Comment, Mentions, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_ADD_KOMMENTAR, payload: {success: data.success, message: translate("Action.Project.Comment.create")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR, payload: {success: data.success, message: translate("Error.Project.Comment.create")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_KOMMENTAR, payload: {success: false, message: translate("Error.Project.Comment.create")}})
      console.log(err)
    })
  }
}
export const updateCommentToCard = (Afid, Userid, Card, BoardId, ProjectId, Comment, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_KOMMENTAR})
    axios.put('projekt/board/card/comment', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Comment, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_UPDATE_KOMMENTAR, payload: {success: data.success, message: translate("Action.Project.Comment.save")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR, payload: {success: data.success, message: translate("Error.Project.Comment.save")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_KOMMENTAR, payload: {success: false, message: translate("Error.Project.Comment.save")}})
      console.log(err)
    })
  }
}
export const deleteCommentToCard = (Afid, Userid, CardId, BoardId, ProjectId, CommentId, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_DELETE_KOMMENTAR})
    axios.delete('projekt/board/card/comment', {
      params:{Afid, Userid, CardId, BoardId, ProjectId, CommentId, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_DELETE_KOMMENTAR, payload: {success: data.success, message: translate("Action.Project.Comment.delete")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR, payload: {success: data.success, message: translate("Error.Project.Comment.delete")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_KOMMENTAR, payload: {success: false, message: translate("Error.Project.Comment.delete")}})
      console.log(err)
    })
  }
}
export const addMedarbetareToCard = (Afid, Userid, Card, BoardId, ProjectId, Medarbetare, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_ADD_MEDARBETARE})
    axios.post('projekt/board/card/medarbetare', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Medarbetare, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_ADD_MEDARBETARE, payload: {success: data.success, message: translate("Action.Project.Recipient.add")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE, payload: {success: data.success, message: translate("Error.Project.Recipient.add")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_MEDARBETARE, payload: {success: false, message: translate("Error.Project.Recipient.add")}})
      console.log(err)
    })
  }
}
export const deleteMedarbetareToCard = (Afid, Userid, CardId, BoardId, ProjectId, MUserid, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_DELETE_MEDARBETARE})
    axios.delete('projekt/board/card/medarbetare', {
      params:{Afid, Userid, CardId, BoardId, ProjectId, MUserid, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_DELETE_MEDARBETARE, payload: {success: data.success, message: translate("Action.Project.Recipient.delete")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE, payload: {success: data.success, message: translate("Error.Project.Recipient.delete")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_MEDARBETARE, payload: {success: false, message: translate("Error.Project.Recipient.delete")}})
      console.log(err)
    })
  }
}
export const updateCardBeskrivning = (Afid, Userid, Card, BoardId, ProjectId, Beskrivning, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_BESKRIVNING})
    axios.put('projekt/board/card/desc', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Beskrivning, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_UPDATE_BESKRIVNING, payload: {success: data.success, message: translate("Action.Project.Description.save")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING, payload: {success: data.success, message: translate("Error.Project.Description.save")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_BESKRIVNING, payload: {success: false, message: translate("Error.Project.Description.save")}})
      console.log(err)
    })
  }
}
export const updateCardTitel = (Afid, Userid, Card, BoardId, ProjectId, Titel, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_TITEL})
    axios.put('projekt/board/card/title', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Titel, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_UPDATE_TITEL, payload: {success: data.success, message:translate("Action.Project.title.save")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_TITEL, payload: {success: data.success, message: translate("Error.Project.title.save")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_TITEL, payload: {success: false, message: translate("Error.Project.title.save")}})
      console.log(err)
    })
  }
}
export const updateCardStatus = (Afid, Userid, Card, BoardId, ProjectId, Status, Comment={}, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_STATUS})
    axios.put('projekt/board/card/status', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Status, Comment, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success) {
          let message = translate("Action.Project.status.update")
          let type = 'success'
          if(parseInt(Status) === 0) {
            message = translate("Action.Project.Card.Archived")
            type = 'warning'
          }
          if(parseInt(Status) === 2) {
            message = translate("Action.Project.Card.Complete")
          }
          dispatch({type: PROJEKT_KORT_ON_UPDATE_STATUS, payload: {success: data.success, message, type}})
        }
        else {
          let message = translate("Error.Project.status.update")
          let type = 'error'
          if(parseInt(Status) === 0) {
            message = translate("Error.Project.Card.Archived")
          }
          if(parseInt(Status) === 2) {
            message = translate("Error.Project.Card.Complete")
          }
          dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_STATUS, payload: {success: data.success, message, type}})
        }
    }).catch(err => {
      let message = translate("Error.Project.status.update")
      let type = 'error'
      if(parseInt(Status) === 0) {
        message = translate("Error.Project.Card.Archived")
      }
      if(parseInt(Status) === 2) {
        message =  translate("Error.Project.Card.Complete")
      }
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_STATUS, payload: {success: false, message, type}})
      console.log(err)
    })
  }
}
export const updateCardDeadline = (Afid, Userid, Card, BoardId, ProjectId, Deadline, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_DEADLINE})
    axios.put('projekt/board/card/deadline', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Deadline, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_UPDATE_DEADLINE, payload: {success: data.success, message: translate("Action.Project.DueDate.update")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE, payload: {success: data.success, message: translate("Error.Project.DueDate.update")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_DEADLINE, payload: {success: false, message: translate("Error.Project.DueDate.update")}})
      console.log(err)
    })
  }
}
export const addLabelToCard = (Afid, Userid, Card, BoardId, ProjectId, Label, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_ADD_LABEL})
    axios.post('projekt/board/card/label', {
      body: {Afid, Userid, Card, BoardId,ProjectId, Label, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_ADD_LABEL, payload: {success: data.success, message: translate("Action.Project.Etickette.Add")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_LABEL, payload: {success: data.success, message: translate("Error.Project.Etickette.Add")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_LABEL, payload: {success: false, message: translate("Error.Project.Etickette.Add")}})
      console.log(err)
    })
  }
}
export const deleteLabelToCard = (Afid, Userid, CardId, BoardId, ProjectId, LabelId, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_REMOVE_LABEL})
    axios.delete('projekt/board/card/label', {
      params:{Afid, Userid, CardId, BoardId, ProjectId, LabelId, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_REMOVE_LABEL, payload: {success: data.success, message: translate("Action.Project.Etickette.Delete")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_REMOVE_LABEL, payload: {success: data.success, message: translate("Error.Project.Etickette.Delete")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_REMOVE_LABEL, payload: {success: false, message: translate("Error.Project.Etickette.Delete")}})
      console.log(err)
    })
  }
}
export const addAttachmentToCard = (Afid, Userid, CardId, BoardId, ProjectId, Attachments = [], files = [], Extern = 0, document = {}, opt = 1) => {
  const ipAdress='0.0.0.0'


  const formData = new FormData()
  
  
  files.forEach(file => formData.append('files[]', file));
  formData.append('Userid', Userid);
  formData.append('Attachments', JSON.stringify(Attachments));
  formData.append('document', JSON.stringify(document));
  formData.append('Afid', Afid);
  formData.append('CardId', CardId);
  formData.append('ProjectId', ProjectId);
  formData.append('BoardId', BoardId);
  formData.append('Extern', Extern);
  formData.append('opt', opt);
  formData.append('ipAdress', ipAdress);

  
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_ADD_ATTATCHMENT})
    axios.post('projekt/board/card/attach', 
    formData,{
      body: {Afid, Userid, CardId, BoardId,ProjectId, Attachments:JSON.stringify(Attachments), document: JSON.stringify(document), Extern,ipAdress, opt, },
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_ADD_ATTATCHMENT, payload: {success: data.success, message: translate("Action.Project.Attachment.add")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT, payload: {success: data.success, message: translate("Error.Project.Attachment.add")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_ATTATCHMENT, payload: {success: false, message: translate("Error.Project.Attachment.add")}})
      console.log(err)
    })
  }
}
export const deleteAttatchmentToCard = (Afid, Userid, CardId, BoardId, ProjectId, AttachId, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_DELETE_ATTATCHMENT})
    axios.delete('projekt/board/card/attach', {
      params:{Afid, Userid, CardId, BoardId, ProjectId, AttachId, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_DELETE_ATTATCHMENT, payload: {success: data.success, message: translate("Action.Project.Attachment.delete")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT, payload: {success: data.success, message: translate("Error.Project.Attachment.delete")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_ATTATCHMENT, payload: {success: false, message: translate("Error.Project.Attachment.delete")}})
      console.log(err)
    })
  }
}
export const setCardCover = (Afid, Userid, Card, BoardId, ProjectId, AttachId, Cover, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_MAKE_COVER})
    axios.put('projekt/board/card/cover', {
      body: {Afid, Userid, Card, BoardId,ProjectId, AttachId,Cover, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_MAKE_COVER, payload: {success: data.success, message: translate("Action.Project.Cover.update")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_MAKE_COVER, payload: {success: data.success, message: translate("Error.Project.Cover.update")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_MAKE_COVER, payload: {success: false, message: translate("Error.Project.Cover.update")}})
      console.log(err)
    })
  }
}
export const addCheckListToCard = (Afid, Userid, Card, BoardId, ProjectId, CheckList, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_ADD_CHECKLIST})
    axios.post('projekt/board/card/checklist', {
      body: {Afid, Userid, Card, BoardId,ProjectId, CheckList, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_ADD_CHECKLIST, payload: {success: data.success, message: translate("Action.Project.CheckList.create")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST, payload: {success: data.success, message: translate("Error.Project.CheckList.create")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST, payload: {success: false, message: translate("Error.Project.CheckList.create")}})
      console.log(err)
    })
  }
}
export const followCard = (Afid, Userid, Card, Follow = false, BoardId, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_FOLLOW_CARD})
    axios.post('projekt/board/card/follow', {
      body: {Afid, Userid, Card, BoardId, Extern, Follow, ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_FOLLOW_CARD, payload: {success: data.success, message: Follow ? translate("Action.Project.Card.Follow") : translate("Action.Project.Card.unFollow")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_FOLLOW_CARD, payload: {success: data.success, message:translate("Error.Project.Card.Follow",`Kunde inte ${Follow ? 'följa' : 'avfölja'} kort`,{item:Follow ? 'följa' : 'avfölja'})}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_FOLLOW_CARD, payload: {success: false, message: translate("Error.Project.Card.Follow",`Kunde inte ${Follow ? 'följa' : 'avfölja'} kort`,{item:Follow ? 'följa' : 'avfölja'})}})
      console.log(err)
    })
  }
}
export const updateCheckListToCard = (Afid, Userid, Card, BoardId, ProjectId, CheckList, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_CHECKLIST})
    axios.put('projekt/board/card/checklist', {
      body: {Afid, Userid, Card, BoardId,ProjectId, CheckList, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_UPDATE_CHECKLIST, payload: {success: data.success, message: translate("Action.Project.Checklist.save")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST, payload: {success: data.success, message: translate("Error.Project.Checklist.save")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST, payload: {success: false, message: translate("Error.Project.Checklist.save")}})
      console.log(err)
    })
  }
}
export const deleteCheckListToCard = (Afid, Userid, CardId, BoardId, ProjectId, CheckListId, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_DELETE_CHECKLIST})
    axios.delete('projekt/board/card/checklist', {
      params:{Afid, Userid, CardId, BoardId, ProjectId, CheckListId, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_DELETE_CHECKLIST, payload: {success: data.success, message: translate("Action.Project.Checklist.delete")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST, payload: {success: data.success, message: translate("Error.Project.Checklist.delete")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST, payload: {success: false, message: translate("Error.Project.Checklist.delete")}})
      console.log(err)
    })
  }
}
export const addCheckListItemToCard = (Afid, Userid, Card, BoardId, ProjectId, CheckListId, CheckListItem, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_ADD_CHECKLIST_ITEM})
    axios.post('projekt/board/card/checklistitem', {
      body: {Afid, Userid, Card, BoardId,ProjectId, CheckListId,CheckListItem, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_ADD_CHECKLIST_ITEM, payload: {success: data.success, message: translate("Action.Project.information.save")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM, payload: {success: data.success, message: translate("Error.Project.information.save")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_ADD_CHECKLIST_ITEM, payload: {success: false, message: translate("Error.Project.information.save")}})
      console.log(err)
    })
  }
}
export const updateCheckListItemToCard = (Afid, Userid, Card, BoardId, ProjectId, CheckListItem, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_UPDATE_CHECKLIST_ITEM})
    axios.put('projekt/board/card/checklistitem', {
      body: {Afid, Userid, Card, BoardId,ProjectId, CheckListItem, Extern,ipAdress}
    },{
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_UPDATE_CHECKLIST_ITEM, payload: {success: data.success, message: translate("Action.Project.information.update")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM, payload: {success: data.success, message: translate("Error.Project.information.update")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_UPDATE_CHECKLIST_ITEM, payload: {success: false, message: translate("Error.Project.information.update")}})
      console.log(err)
    })
  }
}
export const deleteCheckListItemToCard = (Afid, Userid, CardId, BoardId, ProjectId, ChecklistItemId, Extern = 0) => {
  const ipAdress='0.0.0.0'
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    dispatch({type: PROJEKT_KORT_ON_START_DELETE_CHECKLIST_ITEM})
    axios.delete('projekt/board/card/checklistitem', {
      params:{Afid, Userid, CardId, BoardId, ProjectId, ChecklistItemId, Extern,ipAdress},
      headers: {
        //  'Authorization':`Bearer ${jwt}`
        }}
      ).then(({data}) => {
        if(data.success)dispatch({type: PROJEKT_KORT_ON_DELETE_CHECKLIST_ITEM, payload: {success: data.success, message: translate("Action.Project.information.delete")}})
        else dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM, payload: {success: data.success, message: translate("Error.Project.information.delete")}})
    }).catch(err => {
      dispatch({type: PROJEKT_KORT_ON_ERROR_DELETE_CHECKLIST_ITEM, payload: {success: false, message: translate("Error.Project.information.delete")}})
      console.log(err)
    })
  }
}

//Etiketter
export const createTag = (Afid, Userid,ProjectId, Tag) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/tag/add', {
      body: {Afid, Userid, Tag,ProjectId},
      headers: { 
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
      if(data.success)dispatch(getProjectTags(Afid, Userid,ProjectId))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getProjectTags =(Afid, Userid, ProjectId) => {
  return async (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    await axios.get('projekt/tag/get', {
      params: {Afid, Userid, ProjectId},
      headers: { 
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
      dispatch({type: PROJEKT_ON_GET_TAGS, payload: data})
      // dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateProjectTag = (Afid, Userid,ProjectId, Tag) => {
  return (dispatch) => {
    // const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/tag/update', {
      body: {Afid, Userid, Tag,ProjectId}
    },{
      headers: { 
        // 'Authorization':`Bearer ${jwt}`
      }}
      ).then(({data}) => {
      if(data.success) dispatch(getProjectTags(Afid, Userid,ProjectId))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteProjectTag = (Afid, Userid,ProjectId, TagId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/tag/delete', {
      params:{Afid, Userid,TagId},
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
      if(data.success) dispatch(getProjectTags(Afid, Userid,ProjectId))
    }).catch(err => {
      console.log(err)
    })
  }
}


//Dokument
export const AddDocByProjectId = (ProjectId, Userid, files, Afid, Orgnr, page, FileName) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    
    formData.append('ProjectId', ProjectId);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('Orgnr', Orgnr);

    files.forEach(file => formData.append('files[]', file));

    axios.post('projekt/doc/add', 
    formData,
    {
      body: {
        Userid,
        ProjectId,
        Afid,
        Orgnr
      },
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
      }
    }
    ).then(({data}) => {
      console.log(data)
      dispatch(GetDocByProjectId(Userid, ProjectId, (page - 1)))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const GetDocByProjectId = ( Userid, ProjectId, Offset,SortBy={label:"sdate",Method:"desc"}) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_DOKUMENT})
    axios.get('projekt/doc/get',
    { params:{ Userid, ProjectId, Offset,SortBy}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      // console.log(data)
      dispatch({type: PROJEKT_ON_GET_DOKUMENT, payload: data})
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       console.log(error)
     });
  }
}
export const ProjectRemoveDocById = (Userid, ProjectId, Offset, DocId, Mallmodul) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/doc/delete', { params:{DocId, Userid, Mallmodul},headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then(({data}) => {
      dispatch(GetDocByProjectId(Userid, ProjectId, Offset))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getProjectStats = ( Afid, Userid, ProjectId) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('projekt/stats',
    { params:{ Afid, Userid, ProjectId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log(data)
      dispatch({type: PROJEKT_ON_GET_STATS, payload: data})
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       console.log(error)
     });
  }
}

export const getBoardAktivitet = ( Afid, Userid, BoardId, Limit) => {
  // const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_THIS_BOARD_AKTIVITET})
    axios.get('projekt/board/aktivitet',
    { params:{ Afid, Userid, BoardId, Limit}, 
     headers: { 
      // 'Authorization': `Bearer ${jwt}`
    } }      
     ).then(({data}) => {
      dispatch({type: PROJEKT_ON_GET_THIS_BOARD_AKTIVITET, payload: data})
      // dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
      dispatch({type: PROJEKT_ON_ERROR_GET_THIS_BOARD_AKTIVITET})
      console.log(error)
     });
  }
}
export const addExternPartBoard = ( Afid, Userid, BoardId, Mottagare, Message, Subject) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_ADD_EXTERN_PART_BOARD})
    axios.post('projekt/board/addExternPart', {body: {
      Afid, Userid, BoardId, Mottagare, Message, Subject
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      dispatch({type: PROJEKT_ON_ADD_EXTERN_PART_BOARD, payload: data.results})
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
      dispatch({type: PROJEKT_ON_ERROR_ADD_EXTERN_PART_BOARD})
      console.log(error)
     });
  }
}
export const getBoardByToken = (Token, Cdate, Init) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_BOARD_BY_TOKEN, payload:Init})
    axios.get('projekt/board/getBoardByToken',
    { params:{ Token, Cdate }, 
     headers: { } }      
     ).then(({data}) => {
      if(data.success) {
        dispatch({type: PROJEKT_ON_GET_BOARD_BY_TOKEN, payload: {board: data.result, projekt: data.Projekt, ExternUser: data.ExternUser, newData: data.newData}})
        history.location.state = {
          Projekt:  data.Projekt,
          Board: data.result
        }
      } 
      else dispatch({type: PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN, payload: data.error})
     }).catch(function (error) {
      dispatch({type: PROJEKT_ON_ERROR_GET_BOARD_BY_TOKEN, payload: translate("Error.Project.board.fetch")})
      console.log(error)
     });
  }
}
// PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN,
// PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN,
// PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN,
export const getBoardListByToken = (Token) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN})
    axios.get('projekt/board/getBoardListByToken',
    { params:{ Token }, 
     headers: { } }      
     ).then(({data}) => {
      if(data.success) {
        dispatch({type: PROJEKT_ON_GET_BOARD_LIST_BY_TOKEN, payload: data})
      } 
      else dispatch({type: PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN, payload: data.error})
     }).catch(function (error) {
      dispatch({type: PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN, payload: translate("Error.Project.board.fetch")})
      console.log(error)
     });
  }
}
export const getBoardListByUser = (Userid, Afid) => {
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_BOARD_LIST_BY_TOKEN})
    axios.get('projekt/board/getBoardListByUser',
    { params:{ Userid, Afid }, 
     headers: { } }      
     ).then(({data}) => {
      if(data.success) {
        dispatch({type: PROJEKT_ON_GET_BOARD_LIST_BY_USER, payload: data})
      } 
      else dispatch({type: PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN, payload: data.error})
     }).catch(function (error) {
      dispatch({type: PROJEKT_ON_ERROR_GET_BOARD_LIST_BY_TOKEN, payload: translate("Error.Project.board.fetch")})
      console.log(error)
     });
  }
}
export const getProjectHistorik = ( Afid, Userid, ProjectId) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('projekt/historik',
    { params:{ Afid, Userid, ProjectId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      dispatch({type: PROJEKT_ON_GET_HISTORIK, payload: data})
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       console.log(error)
     });
  }
}
export const addTime = (Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category, Offset,Start,End, Filterstate, FHours=0, BoardId=null) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/time/add', {
      body: {Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category,Start,End, FHours, BoardId}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
      if(data.success) dispatch(getRegisteredTime(Afid, Userid,ProjectId,Offset,Filterstate))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const addTimeAtTimePage = (Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category, Start, End, Filterstate, Searchword, StatusFilter, View, DateObj, FHours = 0, BoardId = null) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/time/add', {
      body: {Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category,Start,End, FHours, BoardId}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
      if(data.success) dispatch(getProjectsTimeReport(Afid, Userid,Searchword, StatusFilter,Filterstate, View, DateObj, false))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const editTimeAtTimePage = (Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category, Start, End, TimeId, Filterstate, Searchword, StatusFilter, View, DateObj, FHours=0, BoardId = null) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/time/update', {
      body: {Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category,Start,End, TimeId,FHours, BoardId}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
      if(data.success) dispatch(getProjectsTimeReport(Afid, Userid,Searchword, StatusFilter,Filterstate, View, DateObj, false))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const editTime = (Afid, Userid, ProjectId, Hours, Comment, Time, Type, Category, Offset,Start,End, TimeId, Filterstate, CalendarFlag, FHours = 0, BoardId = null) => {
  return (dispatch) => {
		dispatch({type:PROJEKT_START_UPDATE_CALENDAR_EVENT})
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/time/update', {
      body: {Afid, Userid,ProjectId, Hours, Comment, Time, Type, Category,Start,End, TimeId, FHours, BoardId}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
      if(data.success){
				dispatch({type:PROJEKT_UPDATE_CALENDAR_EVENT})
        if(isUndefined(CalendarFlag))dispatch(getRegisteredTime(Afid, Userid,ProjectId,Offset,Filterstate))
        else dispatch(getProjektCalendarEvent( Afid, Userid, ProjectId, Filterstate ))
      }
			else dispatch({type:PROJEKT_ERROR_UPDATE_CALENDAR_EVENT})
    }).catch(err => {
			dispatch({type:PROJEKT_ERROR_UPDATE_CALENDAR_EVENT})
      console.log(err)
    })
  }
}
export const setFakturerbarTime = (Afid, Userid, ProjectId, Offset, Filterstate, TimeArr, Type) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/time/update/time', {
      body: {Afid, Userid,ProjectId,TimeArr,Type}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
      if(data.success)dispatch(getRegisteredTime(Afid, Userid,ProjectId,Offset,Filterstate))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getRegisteredTime = ( Afid, Userid, ProjectId, Offset, Filterstate) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('projekt/time/get',
    { params:{ Afid, Userid, ProjectId, Offset, Filterstate}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      dispatch({type: PROJEKT_GET_REGISTERED_TIME, payload: data})
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       console.log(error)
     });
  }
}
export const deleteTime = (Afid, Userid, ProjectId, Offset, TidId, FilterState) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/time/delete', { params:{TidId, Userid},headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then(({data}) => {
        dispatch(getRegisteredTime(Afid, Userid,ProjectId,Offset, FilterState))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const addProjektTimeType = (Afid, Userid, TypeName, Color,FortnoxCode) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.post('projekt/timeType', {
      body: {Afid, Userid, TypeName, Color, FortnoxCode}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
        if (data.success) {
          dispatch({type: ON_ADD_PROJEKT_TIME_TYPE, payload: data.results});
          dispatch(getProjektTimeTypes(Afid, Userid))          
        }
        else{
          dispatch({type: ON_ERROR_ADD_PROJEKT_TIME_TYPE, payload: data.message});
        }
    }).catch(err => {
      console.log(err)
    })
  }
}
//

//
export const updateProjektTimeType = (Afid, Userid, NewType) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.put('projekt/timeType', {
      body: {Afid, Userid, NewType}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
        if (data.success) {
          dispatch({type: ON_UPPDATE_PROJEKT_TIME_TYPE, payload: data.results});
          dispatch(getProjektTimeTypes(Afid, Userid))          
        }
        else{
          dispatch({type: ON_ERROR_ADD_PROJEKT_TIME_TYPE, payload: data.message});
        }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteProjektTimeType = (Afid, Userid, TypeId,TypeName) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.delete('projekt/timeType', { params:{Afid, Userid, TypeId,TypeName},headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then(({data}) => {
        if (data.success) {
          dispatch({type: ON_DELETE_PROJEKT_TIME_TYPE, payload: data.results});
          dispatch(getProjektTimeTypes(Afid, Userid))          
        }
        else{
          dispatch({type: ON_ERROR_ADD_PROJEKT_TIME_TYPE, payload: data.message});
        }
    }).catch(err => {
      console.log(err)
    })
  }
}

export const addProjektTimeCategory = (Afid, Userid, CategoryName, TypeId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.post('projekt/timeCategory', {
      body: {Afid, Userid, CategoryName, TypeId}
    },{
      headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
        if (data.success) {
          dispatch({type: ON_NEW_PROJEKT_TIME_TYPE_CATEGORY, payload: data.results});
          dispatch(getProjektTimeTypes(Afid, Userid))          
        }
        else{
          dispatch({type: ON_ERROR_ADD_PROJEKT_TIME_TYPE, payload: data.message});
        }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteProjektTimeCategory = (Afid, Userid, CategoryId,CategoryMeta) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_ADD_PROJEKT_TIME_TYPE});
    axios.delete('projekt/timeCategory', { params:{Afid, Userid, CategoryId,CategoryMeta},headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then(({data}) => {
        if (data.success) {
          dispatch({type: ON_DELETE_PROJEKT_TIME_TYPE_CATEGORY, payload: data.results});
          dispatch(getProjektTimeTypes(Afid, Userid))          
        }
        else{
          dispatch({type: ON_ERROR_ADD_PROJEKT_TIME_TYPE, payload: data.message});
        }
    }).catch(err => {
      console.log(err)
    })
  }
}

//onCheckHasPlaning
export const onCheckHasPlaning = ( Afid, Userid,Users, fromTime,ToTime, ExcludeEventId ) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_CHECK_PLANING_USER});
    axios.get('projekt/planing/check',
    { params:{ Afid, Userid,fromTime,ToTime,Users,ExcludeEventId }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if(data.success)dispatch({type: PROJEKT_GET_CHECK_PLANING_USER, payload: data.results})
     }).catch(function (error) {
       console.log(error)
     });
  }
}
//
export const getProjektTimeTypes = ( Afid, Userid ) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    axios.get('projekt/timeTypes',
    { params:{ Afid, Userid }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if(data.success)dispatch({type: PROJEKT_GET_TIME_TYPES, payload: data.TimeTypes})
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       console.log(error)
     });
  }
}

export const addProjektCalendarEvent = (Afid, Userid, ProjectId, Start, End, Typ, Beskrivning, PlaneradH, AUserid, PlaneringsVy = 0, Medarbetare,TimeType, TimeCategory, BoardId = null, CreateOutlookEvent) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.post('projekt/calendarEvents', {
      body: {Afid, Userid, ProjectId, Start, End, Typ, Beskrivning, PlaneradH, AUserid, Medarbetare, TimeType, TimeCategory, BoardId, CreateOutlookEvent},
      }, {headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
        console.log(data)
      if(data.success)dispatch(getProjektCalendarEvent(Afid, Userid, PlaneringsVy === 1 ? 0 : ProjectId))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getProjektCalendarEvent = ( Afid, Userid, ProjectId, _Filterstate, Search = '', Range ) => {
  const jwt =  JSON.parse(localStorage.token);

  const Filterstate = isUndefined(_Filterstate) ? [] : _Filterstate
  return (dispatch) => {
		dispatch({type: PROJEKT_START_GET_CALENDAR_EVENTS})
    axios.get('projekt/calendarEvents',
    { params:{ Afid, Userid,ProjectId,Filterstate, Search, Range }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      if(data.success) dispatch({type: PROJEKT_GET_CALENDAR_EVENTS, payload: data.results})
      else dispatch({type: PROJEKT_ERROR_GET_CALENDAR_EVENTS})

      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
      	dispatch({type: PROJEKT_ERROR_GET_CALENDAR_EVENTS})
       console.log(error)
     });
  }
}
export const updateProjektCalendarEvent = (Afid, Userid, ProjectId, Event) => {
  return (dispatch) => {
		dispatch({type:PROJEKT_START_UPDATE_CALENDAR_EVENT})
    const jwt =  JSON.parse(localStorage.token);
    axios.put('projekt/calendarEvents', {
      body: {Afid, Userid,ProjectId, Event},
    }, {headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
				if(data.success){
					dispatch({type:PROJEKT_UPDATE_CALENDAR_EVENT})
					dispatch(getProjektCalendarEvent(Afid, Userid,ProjectId))
				}
				else dispatch({type:PROJEKT_ERROR_UPDATE_CALENDAR_EVENT})
    }).catch(err => {
			dispatch({type:PROJEKT_ERROR_UPDATE_CALENDAR_EVENT})
      console.log(err)
    })
  }
}
export const getProjektCalendarEventOutlookStatus = (Afid, Userid, Event)=>{
  return (dispatch) => {
		dispatch({type:PROJEKT_ON_START_GET_USERS_OUTLOOK_STATUS })
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/calendarEventsOutlookStatus', {
      params: {Afid, Userid, Event},
    headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
			if(data.success){
				dispatch({type:PROJEKT_ON_GET_USERS_OUTLOOK_STATUS, payload:data })
			}
			else {
				dispatch({type:PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS })
			}
        console.log(data)
    }).catch(err => {
			dispatch({type:PROJEKT_ON_ERROR_GET_USERS_OUTLOOK_STATUS })
      console.log(err)
    })
  }
}
export const getProjektPlannedTimePreset = (Afid, Userid, ProjectId, Start, End)=>{
  return (dispatch) => {
		dispatch({type:PROJEKT_ON_START_GET_PLANNED_TIME_PRESET })
    const jwt =  JSON.parse(localStorage.token);
    axios.get('projekt/plannedTimePreset', {
      params: {Afid, Userid, ProjectId, Start, End},
    headers: { 'Authorization':`Bearer ${jwt}`}}
      ).then(({data}) => {
			if(data.success){
				dispatch({type:PROJEKT_ON_GET_PLANNED_TIME_PRESET, payload:data })
			}
			else {
				dispatch({type:PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET })
			}
        console.log(data)
    }).catch(err => {
			dispatch({type:PROJEKT_ON_ERROR_GET_PLANNED_TIME_PRESET })
      console.log(err)
    })
  }
}
export const deleteProjektCalendarEvent = (Afid, Userid, ProjectId, EventId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('projekt/calendarEvents', { params:{Afid, Userid, EventId},headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then(({data}) => {
      if(data.success) dispatch(getProjektCalendarEvent(Afid, Userid,ProjectId))
    }).catch(err => {
      console.log(err)
    })
  }
}

//KALKYL

export const saveNewNormalKalkylProjekt = (Afid,userid,Orderid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_NEW_PROJEKT_KALKYL_ID});
      axios.put('projekt/KalkylNormal/new', {
       method: 'PUT',
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Orderid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveNewNormalKalkylProjekt: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_PROJEKT_KALKYL_ID, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_NEW_PROJEKT_KALKYL_ID, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_PROJEKT_KALKYL_ID, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//  ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
export const updateProjectByMeta = (Afid,userid,Meta,Value,ProjectId,DATA) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: PROJEKT_ON_START_UPDATE_PROJEKT_BY_META});
      if(Meta === 'ProjectStatus') dispatch({type: ON_START_MESSAGE_KUND, payload: Value === 4 ? translate("Action.Project.Completing") : translate("Action.Project.updating.status")});
      axios.put('projekt/update/meta', {
       method: 'PUT',
       body: {
         Afid:Afid,
         userid:userid,
         Meta,
         Value,
         ProjectId
       }      
   },{
    headers: {
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } 
   }).then(({data}) => {
       console.log("updateProjectByMeta: ", data);
        if (data.success) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: PROJEKT_ON_UPDATE_PROJEKT_BY_META, payload: data.results});
          console.log(Meta, 'FFFFFFFFFF')
          console.log(DATA, 'FFFFFFFFFF')
          if(Meta === 'ProjectStatus' && !isEmpty(DATA)) {
            dispatch({type: ON_MESSAGE_KUND, payload: Value === 4 ? translate("Action.Project.Complete") : translate("Action.Project.status.updated")});
            dispatch(getProjects(Afid,userid,DATA.page,DATA.pageSize,DATA.searchword, DATA.statusFilter, DATA.filterState,undefined,DATA.sortObj))
          } 
        } else {
          dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Project.update")});
        dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT_BY_META, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveNewAbonnemangKalkylOrder
 export const saveNewAbonnemangKalkylProjekt = (Afid,userid,Aid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_NEW_PROJEKT_ABOKALKYL_ID});
      axios.put('projekt/KalkylAbonnemange/new', {
       method: 'PUT',
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveNewAbonnemangKalkylProjekt: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_PROJEKT_ABOKALKYL_ID, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_PROJEKT_ABOKALKYL_ID, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//getOrderKalkylById
//
export const onSaveProjectCalcItems = (ProjectId, Orgnr, CalcItems, CalcItemsUpdatesArr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_SAVE_PROJEKT_CALC_ITEMS});
      axios.post('projekt/onSaveProjectCalcItems', {
        ProjectId, Orgnr, CalcItems, CalcItemsUpdatesArr, ProjectId
      }, 
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      }).then(({data}) => {
       console.log("onSaveProjectCalcItems: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_SAVE_PROJEKT_CALC_ITEMS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_SAVE_PROJEKT_CALC_ITEMS, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_SAVE_PROJEKT_CALC_ITEMS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
export const getProjektKalkylById = (Orgrn,Afid,userid,Project,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_PROJEKT_KALKYL_ID});
    axios.get('projekt/getKalkylById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Project:Project}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProjektKalkylById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_PROJEKT_KALKYL_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROJEKT_KALKYL_ID, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROJEKT_KALKYL_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//deleteThisRowKalkylOrder
export const deleteThisRowKalkylProjekt = (Afid,userid,nrad) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_PROJEKT_KALKYL_RAD});
     axios.delete('projekt/Kalkyl/delete', {
       method: 'DELETE',
       data: {
         rad:nrad,
         Afid:Afid,
         userid:userid
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisRowKalkylProjekt: ", data.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_PROJEKT_KALKYL_RAD, payload: data.results});
     } else {
       dispatch({type: ON_ERROR_DELETE_PROJEKT_KALKYL_RAD, payload: data.error});
     }
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_PROJEKT_KALKYL_RAD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//UpdateNormalKalkylProjekt
export const UpdateNormalKalkylProjekt = (Afid,userid,Orderid,Orgnr,Kalkyl,newKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_UPDATE_PROJEKT_KALKYL_RAD});
      axios.put('projekt/Kalkyl/All/update', {
       method: 'PUT',
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         Orgnr:Orgnr,
         newKalkyl:newKalkyl,
         Kalkyl:Kalkyl
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updateThisRowKalkylProjekt: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_PROJEKT_KALKYL_RAD, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//updateThisRowKalkylOrder
export const updateThisRowKalkylProjekt = (Afid,userid,nrad) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_UPDATE_PROJEKT_KALKYL_RAD});
      axios.put('projekt/Kalkyl/update', {
       method: 'PUT',
       body: {
         Afid:Afid,
         userid:userid,
         nrad:nrad
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updateThisRowKalkylProjekt: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_PROJEKT_KALKYL_RAD, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_PROJEKT_KALKYL_RAD, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }

 export const getProjectOrderById = (Afid,userid,ProjectId,page,FilterState=[]) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ORDER_ORGNR_PROJEKT});
    axios.get('projekt/order/get',
    { params:{Afid:Afid,userid:userid,ProjectId:ProjectId,page:page,ipAdress,FilterState}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalOrderById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ORDER_ORGNR_PROJEKT, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ORDER_ORGNR, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}
export const goToBoardById = (Afid, Userid, BoardId, cardId) => {
  const jwt =  JSON.parse(localStorage.token);
  const CardId = isUndefined(cardId) ? 0 : cardId
  return async (dispatch) => {
   const ipAdress='0.0.0.0'
   dispatch({type: PROJEKT_ON_START_GO_TO_BOARD})
   axios.get('projekt/goToBoardById',
   { params:{Afid, Userid, BoardId, ipAdress, CardId}, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
     console.log("goToBoardById: ", data);
      if (data.results) {
        const {Board,Projekt, currentCard} = data.results
        console.log('Board', Board)
        console.log('Projekt', Projekt)
        history.push(
          {
            pathname: '/app/Projektdel',
            state: { 
              Board: Board, 
              Projekt: Projekt, 
              currentCard: currentCard
            }
          }
        )
        dispatch({type: PROJEKT_ON_GO_TO_BOARD, payload: currentCard})
      } else {
        dispatch({type: PROJEKT_ON_ERROR_GO_TO_BOARD})
     }
     dispatch(RefreshUserInterface(Userid))
    }).catch(function (error) {
      dispatch({type: PROJEKT_ON_ERROR_GO_TO_BOARD})
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
      if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      } 
    }); /**/
 }
}
export const getCurrentProjektTooltipInfo = (userid,Afid,ProjectId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_TOOLTIPINFO});
    axios.get('projekt/tooltip',
    { params:{Afid:Afid,userid:userid,ProjectId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getCurrentProjektTooltipInfo: ", data);
       if (data.results) {
         dispatch({type: PROJEKT_ON_GET_TOOLTIPINFO, payload: data.results});
       } else {
         dispatch({type: PROJEKT_ON_ERROR_GET_TOOLTIPINFO, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: PROJEKT_ON_ERROR_GET_TOOLTIPINFO, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onSaveThisProjectFortnoxS
export const onCreateNewFortnoxProject = (Afid,userid,Projekt,FortnoxProject) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: PROJEKT_ON_START_UPDATE_PROJEKT});
     axios.put('kontos/projekt/Fortnox/new', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Projekt:Projekt,
        FortnoxProject:FortnoxProject
      }
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateAfOrderSittings: ", data);
       if (data.result) {
          dispatch(CgetProject(Afid, userid, Projekt.id)) 
          dispatch({type: PROJEKT_ON_UPDATE_PROJEKT, payload: {message: translate("Action.Project.Fortnox.create")}})
       } else {
         dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT, payload: {message: translate("Error.Project.Fortnox.create")}});
       }
     }).catch(function (error) {
       dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT, payload:{message: translate("Error.Project.Fortnox.create")}});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//onUpdatethisFortnoxProject
export const onUpdatethisFortnoxProject = (Afid,userid,Projekt,FortnoxProject) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: PROJEKT_ON_START_UPDATE_PROJEKT});
     axios.put('kontos/projekt/Fortnox/update', {
      method: 'PUT',
      body: {
        userid:userid,
        Afid:Afid,
        Projekt:Projekt,
        FortnoxProject:FortnoxProject
      }
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("updateAfOrderSittings: ", data);
       if (data.result) {
          dispatch(CgetProject(Afid, userid, Projekt.id)) 
          dispatch({type: PROJEKT_ON_UPDATE_PROJEKT, payload: {message: translate("Action.Project.Fortnox.update")}})
       } else {
         dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT, payload: {message: translate("Error.Project.Fortnox.update")}});
       }
     }).catch(function (error) {
       dispatch({type: PROJEKT_ON_ERROR_UPDATE_PROJEKT, payload:{message: translate("Error.Project.Fortnox.update")}});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     });
   }
 }
//getFortnoxProjekt
export const getFortnoxProjekt = (userid,Afid,ProjectFortnoxId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_FORTNOX_PROJECT});
    axios.get('kontos/projekt/Fortnox/get',
    { params:{Afid:Afid,userid:userid,ProjectFortnoxId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getFortnoxProjekt: ", data);
       if (data.results) {
         dispatch({type: PROJEKT_ON_GET_FORTNOX_PROJECT, payload: data.results});
       } else {
         dispatch({type: PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: PROJEKT_ON_ERROR_GET_FORTNOX_PROJECT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getProjektFakturor
export const getProjektFakturor = (userid,Afid,ProjectId,ProjectFortnoxId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: PROJEKT_ON_START_GET_FORTNOX_INVOICES_PROJECT});
    axios.get('kontos/projekt/Fortnox/invoices/get',
    { params:{Afid:Afid,userid:userid,ProjectFortnoxId,ProjectId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProjektFakturor: ", data);
       if (data.results) {
         dispatch({type: PROJEKT_ON_GET_FORTNOX_INVOICES_PROJECT, payload: data.results});
       } else {
         dispatch({type: PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: PROJEKT_ON_ERROR_GET_FORTNOX_INVOICES_PROJECT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//onGetDetailCard
export const onGetDetailCard = (Afid,cardId,DontSetNull = 0,callbaskFunction) =>{
  return (dispatch) => {
    if(DontSetNull === 0){
    dispatch({type: PROJEKT_ON_START_GET_CARD_DETAILS});
    }
    axios.get('projekt/card/details',
    { 
      params:{Afid:Afid,cardId:cardId}
    }      
     ).then(({data}) => {
      console.log("onGetDetailCard: ", data);
       if (data.results) {
         dispatch({type: PROJEKT_ON_GET_CARD_DETAILS, payload: data.results});
         callbaskFunction()
       } else {
         dispatch({type: PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: PROJEKT_ON_ERROR_GET_GET_CARD_DETAILS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
